import axios from 'axios';
import { ApiLink } from '../APILink/ApiLink';

const getCompanyModule = async (headers) => {
    try {
        const response = await axios.get(ApiLink.API_URL + 'PackContoller/getCompanyModule', { headers });
        // console.log(response.data);

        return response.data[0].Company_Module || null; // Kthe rolin ose null nëse nuk ka
    } catch (error) {
        // console.error("Error fetching role:", error);
        return null; // Kthe null në rast gabimi
    }
};

export default getCompanyModule;
